import { useState } from 'react';
import YearSelectorHeader from './YearSelectorHeader';
import { getYears } from '../../../utils/calendar.utils';

type YearSelectorProps = {
    onYearSelection: (year: number) => void;
    selectedYear: number;
};

export default function YearSelector({
    onYearSelection,
    selectedYear,
}: YearSelectorProps) {
    const [years, setYears] = useState<number[]>(getYears(selectedYear));
    const [startYear, setStartYear] = useState<number>(selectedYear);
    const [endYear, setEndYear] = useState<number | null>(selectedYear + 11);

    const onRangeChange = (direction: boolean) => {
        const year = direction ? years[years.length - 1] : years[0];
        const newYears = getYears(year, direction);
        setYears(newYears);
        setStartYear(newYears[0]);
        setEndYear(newYears[newYears.length - 1]);
    };

    return (
        <>
            <YearSelectorHeader
                startYear={startYear}
                endYear={endYear}
                onYearRangeChange={onRangeChange}
            />
            <div className="alli-mt-6 alli-grid alli-w-full alli-grid-cols-3 alli-gap-6 alli-text-center alli-text-sm alli-text-blue-gray-700 ">
                {years.map((year, idx) => (
                    <button
                        onClick={() => onYearSelection(year)}
                        key={idx}
                        type="button"
                        className={`alli-justify-center alli-px-[10px] alli-py-[6px] ${
                            year !== selectedYear
                                ? 'hover:alli-bg-gray-100'
                                : ''
                        } ${
                            year === selectedYear
                                ? 'alli-bg-blue-600 alli-text-white'
                                : ''
                        }`}>
                        {year}
                    </button>
                ))}
            </div>
        </>
    );
}
